import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=c40c743c&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=ts"
export * from "./Sidebar.vue?vue&type=script&lang=ts"
import style0 from "./Sidebar.vue?vue&type=style&index=0&id=c40c743c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c40c743c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c40c743c')) {
      api.createRecord('c40c743c', component.options)
    } else {
      api.reload('c40c743c', component.options)
    }
    module.hot.accept("./Sidebar.vue?vue&type=template&id=c40c743c&scoped=true", function () {
      api.rerender('c40c743c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/view-editor/Sidebar.vue"
export default component.exports